import { connect } from 'react-redux';
import {
  selectUserIsLoaded,
  selectActiveVenue,
  selectUserPermissions,
  selectSchedulesStartDate,
} from 'selectors/general';
import { selectIsDesktop } from 'selectors/ui';

import { setSelectedSchedule, updateStartDate } from '../YieldManagement.saga';
import { selectActiveScheduleId, selectActiveScheduleDetailTab } from '../YieldManagement.selectors';
import ScheduleList from './ScheduleList';

function mapStateToProps(state, ownProps) {
  const { venueId } = ownProps;

  const startDate = selectSchedulesStartDate(state);
  const scheduleId = selectActiveScheduleId(state);
  const tab = selectActiveScheduleDetailTab(state);
  const isUserLoaded = selectUserIsLoaded(state);
  const { timezone, isManualStudio, directFillDataDisabled } = selectActiveVenue(state);

  return {
    ...ownProps,
    isUserLoaded,
    showDirectFillData: !isManualStudio && !directFillDataDisabled,
    venueTimezone: timezone,
    startDate,
    venueId,
    scheduleId,
    tab,
    permissions: selectUserPermissions(state),
    isDesktop: selectIsDesktop(state),
  };
}

const mapDispatchToProps = {
  setSelectedSchedule,
  updateStartDate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleList);
